import React, { Component } from 'react'
import StyleSheet, { colorPalette } from 'styles/index'
import {Authorization} from 'utils'
import { withRouter } from 'react-router-dom'

class KycBar extends Component{

  get path() {
    return this.props.location.pathname
  }

  render = () =>
    Authorization.promptKyc && !this.path.startsWith('/issuer') && !this.path.startsWith('/investor') &&
    <div className={styles.kycBar}>
      <a href={`/investor/${Authorization.user.id}/edit`}>
        KYC Verification is required. Take me there >
      </a>
    </div>
}

export default withRouter(KycBar)

const styles = StyleSheet({
  kycBar: {
    background: colorPalette.primary[0].hex(),
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontSize: 14,
    color: 'white',
    textAlign: 'center',
    padding: 12,
    width: '100%',
    boxSizing: 'border-box',
    zIndex: 2000,
    '& a': {
      color: 'white',
      textDecoration: 'none'
    }
  }
})
